import React from "react";
import { Box, Typography, Button, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import clsx from "clsx";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import { plans } from "../../data/plans";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: "1.125rem",
    lineHeight: "1.3125rem",
    fontWeight: 700,
    letterSpacing: "1px",
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    fontSize: "0.875rem",
    lineHeight: "1rem",
    fontWeight: 500,
    color: theme.palette.secondary.main
  },
  cardTopText: {
    fontWeight: 500,
    fontSize: "0.8125rem",
    lineHeight: "0.9375rem",
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(0.5)
  },
  price: {
    fontSize: "1.875rem",
    lineHeight: "2.1875rem",
    marginBottom: theme.spacing(0.5),
    fontWeight: 900
  },
  card: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: theme.spacing(1)
  },
  topCard: {
    borderRadius: theme.spacing(1, 1, 0, 0)
  },
  bottomCard: {
    borderRadius: theme.spacing(0, 0, 1, 1),
    marginTop: "1px"
  },
  cardSection: {
    maxWidth: "50%"
  },
  cardSectionRight: {
    textAlign: "right"
  },
  priceInfo: {
    fontSize: "0.875rem",
    lineHeight: "1rem"
  },
  countIndicator: {
    fontSize: "1.125rem",
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    lineHeight: "1.3125em"
  },
  downIcon: {
    color: theme.palette.text.primary
  },
  overViewBtn: {
    fontSize: "0.875rem",
    lineHeight: "1rem",
    padding: theme.spacing(1.25, 1)
  }
}));

function PaymentDetails({
  showOverview,
  chosenPlan,
  vehiclesCount,
  setActiveModal,
  vehiclesOpen,
  currency,
  stripeOpen,
  oldPlan,
  payment,
  successWindow,
  userData
}) {
  const classes = useStyles();

  const oldPlanData = plans.find(plan => plan.name === oldPlan);

  const plan =
    (userData.organisationSite &&
      userData.organisationSite.organisation.plan) ||
    {};

  return (
    <div>
      {
        <Box
          display="flex"
          justifyContent="center"
          style={{ backgroundColor: "#f9f9f9" }}
          pt={3}
          pb={4}
        >
          <Box width="560px">
            {!oldPlanData || (!payment && chosenPlan.name === plan.type) ? (
              <>
                <Typography className={classes.cardTopText}>
                  Your subscription
                </Typography>
                <Box
                  display="flex"
                  className={clsx(classes.topCard, classes.card)}
                  data-cy="customizePlan-upgrade"
                >
                  <div className={classes.cardSection} data-cy="cardSection">
                    <Typography className={classes.title}>
                      {chosenPlan.title}
                    </Typography>
                    <Typography className={classes.subtitle}>
                      {chosenPlan.subtitle}
                    </Typography>
                  </div>
                  <div
                    className={clsx(
                      classes.cardSection,
                      classes.cardSectionRight
                    )}
                  >
                    <Typography
                      className={classes.price}
                      data-cy="priceIndicator"
                    >
                      {!currency.loaded ? (
                        <Skeleton variant="text" />
                      ) : (
                        `${currency.symbol}`
                      )}
                      {chosenPlan.price}
                    </Typography>
                    <Typography className={classes.priceInfo}>
                      per vehicle per month
                    </Typography>
                  </div>
                </Box>
                <Box className={clsx(classes.bottomCard, classes.card)}>
                  <div>
                    <Typography>Fleet size</Typography>
                    <Typography className={classes.countIndicator}>
                      {successWindow && chosenPlan.name === "individual"
                        ? "1 vehicle"
                        : vehiclesCount === 1
                        ? "1 vehicle"
                        : `${vehiclesCount} vehicles`}
                    </Typography>
                  </div>
                  <Box display="flex" alignItems="center">
                    {showOverview && (
                      <Button
                        color="primary"
                        className={classes.overViewBtn}
                        onClick={() => {
                          if (vehiclesOpen) {
                            setActiveModal("");
                          } else {
                            setActiveModal("vehicles");
                          }
                        }}
                        disabled={stripeOpen}
                      >
                        {vehiclesOpen ? "Close overview" : "Open overview"}
                      </Button>
                    )}
                  </Box>
                </Box>
              </>
            ) : (
              <>
                <Typography className={classes.cardTopText}>
                  {!payment && chosenPlan.name !== plan.type
                    ? "Current trial plan"
                    : "Current plan"}
                </Typography>
                <Box
                  display="flex"
                  className={clsx(classes.card, {
                    [classes.topCard]: !payment && chosenPlan.name !== plan.type
                  })}
                  data-cy="customizePlan-current"
                >
                  <div className={classes.cardSection} data-cy="cardSection">
                    <Typography className={classes.title}>
                      {oldPlanData.title}
                    </Typography>
                    <Typography className={classes.subtitle}>
                      {oldPlanData.subtitle}
                    </Typography>
                  </div>
                  <div
                    className={clsx(
                      classes.cardSection,
                      classes.cardSectionRight
                    )}
                  >
                    <Typography
                      className={classes.price}
                      data-cy="priceIndicator"
                    >
                      {!currency.loaded ? (
                        <Skeleton variant="text" />
                      ) : (
                        `${currency.symbol}`
                      )}
                      {oldPlanData.price}
                    </Typography>
                    <Typography className={classes.priceInfo}>
                      per vehicle per month
                    </Typography>
                  </div>
                </Box>
                {!payment && chosenPlan.name !== plan.type && (
                  <Box className={clsx(classes.bottomCard, classes.card)}>
                    <div>
                      <Typography>Fleet size</Typography>
                      <Typography className={classes.countIndicator}>
                        {successWindow && chosenPlan.name === "individual"
                          ? 1
                          : vehiclesCount}{" "}
                        vehicles
                      </Typography>
                    </div>
                    <Box display="flex" alignItems="center">
                      {showOverview && (
                        <Button
                          color="primary"
                          onClick={() => {
                            if (vehiclesOpen) {
                              setActiveModal("");
                            } else {
                              setActiveModal("vehicles");
                            }
                          }}
                          disabled={stripeOpen}
                        >
                          {vehiclesOpen ? "Close overview" : "Open overview"}
                        </Button>
                      )}
                    </Box>
                  </Box>
                )}

                <Box my={2} justifyContent={"center"} display="flex">
                  <ArrowDownwardIcon className={classes.downIcon} />
                </Box>

                <Typography className={classes.cardTopText}>
                  {!payment && chosenPlan.name !== plan.type
                    ? "Chosen plan"
                    : "New plan"}
                </Typography>
                <Box
                  display="flex"
                  className={clsx(classes.card)}
                  data-cy="customizePlan-new"
                >
                  <div className={classes.cardSection} data-cy="cardSection">
                    <Typography className={classes.title}>
                      {chosenPlan.title}
                    </Typography>
                    <Typography className={classes.subtitle}>
                      {chosenPlan.subtitle}
                    </Typography>
                  </div>
                  <div
                    className={clsx(
                      classes.cardSection,
                      classes.cardSectionRight
                    )}
                  >
                    <Typography
                      className={classes.price}
                      data-cy="priceIndicator"
                    >
                      {!currency.loaded ? (
                        <Skeleton variant="text" />
                      ) : (
                        `${currency.symbol}`
                      )}
                      {chosenPlan.price}
                    </Typography>
                    <Typography className={classes.priceInfo}>
                      per vehicle per month
                    </Typography>
                  </div>
                </Box>
              </>
            )}
          </Box>
        </Box>
      }
    </div>
  );
}

const mapStateToProps = state => ({
  vehiclesOpen: state.account.accountDialog,
  vehiclesCount: state.project.vehicleTypes.length,
  payment: state.account.payment,
  userData: state.auth.userData
});

export default connect(mapStateToProps)(PaymentDetails);
